import React from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { createStore } from 'jotai';
import { initDrilldown , initTempDashboard } from '@store/trends/tempDashboard/nocDrilldown/actions';
import tempDashboardSelector from '@store/trends/tempDashboard/nocDrilldown/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import { dimensionPanelAtom, metricPanelAtom, summaryPanelAtom } from '@src/atoms/panels';
import { aiAlertAtom } from '@src/atoms/toggles';
import {
  diagnosticsModeAtom,
  dodAtom,
  logAxisAtom,
  primaryFilterVisibilityAtom,
  sizeAtom,
  sliceAreaAtom,
  unitAtom,
  zoomAreaAtom,
} from '@components/metrics-panel-hz/atoms';
import TempDashboardHoc from '../main/TempDashboardHoc';
import tempDashboard from '../common/tempDashboard';
import AppExperience from './index';
import injectorServer from '../common/injectorServer';

const tempDashboardDetailsSelector = createSelector(
  tempDashboardSelector,
  (tempDashboardStore) => ({
    dashboard: {},
    dashboardType: DASHBOARD_TYPE.TRENDS,
    isFetching: tempDashboardStore.isFetching,
  }),
);

//TODO: combine with share flow init store
function initStore({ dashboard: state = {} }) {
  const store = createStore();

  if ('metricPanel' in state) {
    const {
      size = 's',
      unit = '%',
      sliceArea = null,
      zoomArea = null,
      diagnosticsMode = false,
      logAxis = false,
      primaryFilterVisibility = true,
    }: any = state.metricPanel;
    store.set(sizeAtom, size);
    store.set(unitAtom, unit);
    store.set(sliceAreaAtom, sliceArea);
    store.set(zoomAreaAtom, zoomArea);
    store.set(diagnosticsModeAtom, diagnosticsMode);
    store.set(logAxisAtom, logAxis);
    store.set(primaryFilterVisibilityAtom, primaryFilterVisibility);
  }

  if ('toggles' in state) {
    const { sections, diagnostics } = state.toggles;
    if (sections) {
      const { summary = true, metric = true, dimension = true } = sections;
      store.set(summaryPanelAtom, summary);
      store.set(metricPanelAtom, metric);
      store.set(dimensionPanelAtom, dimension);
    }

    if (diagnostics) {
      const { aiAlert = false, dod = false } = diagnostics;
      store.set(aiAlertAtom, aiAlert);
      store.set(dodAtom, dod);
    }
  }
  return store;
}

function DrilldownDashboard(props) {
  const dispatch = useDispatch();

  const applyCallback = (payload, doneCallback) => {
    dispatch(initDrilldown(payload.dashboard));
    doneCallback();
  };

  return (
    <TempDashboardHoc {...props} applyCallback={applyCallback} initStore={initStore}>
      {({ store }) => <AppExperience {...props} store={store} />}
    </TempDashboardHoc>
  );
}

const TempTrends = compose(
  connect(tempDashboardDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(DrilldownDashboard);

export const TempNocDrilldownDashboard = injectorServer(
  {},
  { pageType: PAGE_TYPE.TEMP_DASHBOARD },
)(TempTrends);

export default TempNocDrilldownDashboard;
